class CollectionMenu extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.menuWrapper = document.querySelector('.collection-menu-list');
    this.button.addEventListener('click', this.toggleCollectionMenuDisplay.bind(this));
  }

  toggleCollectionMenuDisplay() {
    if (!this.menuWrapper) return;
    if (this.menuWrapper.style.maxHeight) {
      this.menuWrapper.style.maxHeight = null;
    } else {
      this.menuWrapper.style.maxHeight = this.menuWrapper.scrollHeight + 'px';
    }
    this.button.classList.toggle('active');
  }
}

customElements.define('collection-menu', CollectionMenu);
